import { render, staticRenderFns } from "./asistencia-capacitacion.vue?vue&type=template&id=d762af78&"
import script from "./asistencia-capacitacion.vue?vue&type=script&lang=js&"
export * from "./asistencia-capacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports